/**
 * Copyright © Veeam Software Group GmbH.
 */

/**
 * Copyright © Veeam Software Group GmbH.
 */

import { action, makeObservable, observable } from 'mobx';
import { CommandMenuItemConfig } from '@veeam/components';

export class ContextMenuStore {
    @observable menuActive = false;
    @observable menuItems: CommandMenuItemConfig[] = [];

    constructor() {
        makeObservable(this);
    }

    @action.bound
    setMenuItems(items: CommandMenuItemConfig[]): void {
        this.menuItems = items.map(x => ({ ...x, isActive: false }));
    }

    @action.bound
    showMenu(): void {
        if (this.menuItems.length === 0) {
            return;
        }

        this.menuActive = true;
    }

    @action.bound
    hideMenu(): void {
        this.menuActive = false;

        this.menuItems.forEach((item) => {
            item.isActive = false;
        });
    }

    @action.bound
    toggleMenu(): void {
        this.menuActive = !this.menuActive;
    }

    findMenuItem(
        fn: (item: CommandMenuItemConfig) => boolean,
        collection: CommandMenuItemConfig[] = this.menuItems,
    ): CommandMenuItemConfig {
        for (let i = 0; i < collection.length; i++) {
            const item = collection[i];

            if (fn(item)) {
                return item;
            }

            if (item.items && item.items.length > 0) {
                const found = this.findMenuItem(fn, item.items);

                if (found) {
                    return found;
                }
            }
        }
    }

    @action.bound
    showSubmenu({ id }: CommandMenuItemConfig): void {
        const item = this.findMenuItem(item => item.id === id);
        if (item) {
            item.isActive = true;
        }
    }

    @action.bound
    hideSubmenu({ id }: CommandMenuItemConfig): void {
        const item = this.findMenuItem(item => item.id === id);
        if (item) {
            item.isActive = false;
        }
    }

    @action.bound
    hideOtherSubmenus({ id }: CommandMenuItemConfig): void {
        const findHappyPath = (collection, initialPath): string[] => {
            let path = [...initialPath];

            for (let i = 0; i < collection.length; i++) {
                const item = collection[i];
                path.push(item.id);

                if (item.id === id) {
                    return path;
                }

                if (item.items && item.items.length > 0) {
                    const happyPath = findHappyPath(item.items, path);

                    if (happyPath.length) {
                        return happyPath;
                    }
                }

                path = [...initialPath];
            }

            return [];
        };

        const happyPath = findHappyPath(this.menuItems, []);

        const traverse = (collection: CommandMenuItemConfig[]) => {
            for (let i = 0; i < collection.length; i++) {
                const item = collection[i];

                if (item.isActive && !happyPath.includes(item.id)) {
                    item.isActive = false;
                }

                if (item.items && item.items.length > 0) {
                    traverse(item.items);
                }
            }
        };

        traverse(this.menuItems);
    }

}
